module.exports = __webpack_public_path__ + "img/20221115楼书4.dbe7bb50.png";